export const webClientId = "487122222788-kvn4di9l4g69n6efnj0bl37ej3no8j5c.apps.googleusercontent.com";
